import axios from 'axios';
import axiosInstance from './axios';
import { Auth } from 'aws-amplify';

const token = localStorage.getItem('Token')


export async function getAWSAPI(path: any) {
    try {
        const response = await axios.get(path, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization" : `${token}`
            },
            'auth': { 
                username:'master-ellow',
                password:'PC2ROg#Z%@'
            }
            
        });
        return response.data
    }
    catch (e: any) {

        if (e.response.status === 401) {
            logout();
        }

        return { error: e.toString() }
    }
}

export async function getAPI(path: string) {
    try {
        const response: any = await axiosInstance.get(path, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('Token')}`
                }
        })
        return response
    } catch (e: any) {
                if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/login'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}


export async function postAPI(path: string, body: any) {
    try {
        const response: any = await axiosInstance.post(path, body, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('Token')}`
                }
        })
        return response
    } catch (e: any) {
            if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/login'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}

export async function putAPI(path: string, body: any) {
    try {
        const response: any = await axiosInstance.put(path, body)
        return response
    } catch (e: any) {
            if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/login'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}

export async function uploadApi(path: string, body: any, contentType: any){
    try {
        const response: any = await axios.put(path, body, {
                    // headers: {
                    //     'Content-Type': contentType
                    // }
                })
        return response
    } catch (e: any) {
            if ( e.toString() === 'NotAuthorizedException: Invalid Refresh Token' || e.toString() === 'No current user' ){
            try {
                await Auth.signOut();
                window.location.href = '/login'; // redirect the user to the login page
            } catch (error) {
                console.log('Error signing out: ', error);
            }
        }
        return { error: e.toString() }
    }
}

async function logout() {
 
    try {
      await Auth.signOut();
      localStorage.clear();
    } catch (error) {
        
    }
} 

const clearStorage = () => {

    localStorage.clear();
 //   window.location.href = window.location.origin + '/login';

}



// export const logout = () => {
//     localStorage.clear();
//     sessionStorage.clear()
//     Auth.signOut()
//         .then(result => {
//         setUserState(null);
//         })
//         .catch(err => {
//         displayObject(err);
//         });
// }

